import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

/**
 * Resolves unknown deep links to the correct home for the current session kind.
 */
@Component({
  selector: 'app-portal-default-redirect',
  template: '',
})
export class PortalDefaultRedirectComponent implements OnInit {
  constructor(private readonly auth: AuthService, private readonly router: Router) {}

  ngOnInit(): void {
    if (!this.auth.getToken()) {
      void this.router.navigate(['/auth/login'], { replaceUrl: true });
      return;
    }
    if (this.auth.isProviderSession()) {
      void this.router.navigate(this.auth.providerHomeUrl(), { replaceUrl: true });
      return;
    }
    void this.router.navigate(['/dashboard'], { replaceUrl: true });
  }
}
